var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('div',{staticClass:"top-option-block"},[_c('router-link',{attrs:{"to":"/schedule","exact":""}},[_vm._v("ปฏิทินนัดหมาย")]),_c('router-link',{attrs:{"to":"/schedule/report","exact":""}},[_vm._v("รายการจองสต๊อค")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }